import styles from './wide-widget-container.module.scss';
import Image from '../image/image.model';
import Header from '../header/header.model';
import Button from '../button/button.model';
import { WideWidgetStyle } from '../wide/wide-widget-style';
import { Subscription } from '../../observer.model';
import { Dentolo } from '../../../dentolo';
import EventEmitter from '../../event-emitter.model';

export default class WideWidgetContainer {
	private image:Image;
	private header:Header;
	private button:Button;
	public element: HTMLDivElement;
	private eventEmitter = new EventEmitter();

	constructor(
    className:WideWidgetStyle='default', 
    wideButtonOnMobiles?:Dentolo.WideButtonOnMobilesOptions,
    offer?: string,
    buttonText?: string,
    buttonShadow?: string
  ) {
		this.element = document.createElement('div');
		this.element.className = styles[className];
		this.element.dataset.nameSpace = 'dentolo';
		this.image = new Image('https://cdn.reserve-donkin-leads.ru/img/phone.webp', className);
		this.header = new Header(offer || 'Рассчитайте предварительную цену, пройдя короткий тест за 20 секунд', className);
		this.button = new Button(buttonText || 'Рассчитать цену онлайн', className, wideButtonOnMobiles, buttonShadow);
		this.element.appendChild(this.image.element);
		this.element.appendChild(this.header.element);
		this.element.appendChild(this.button.element);

		this.element.onclick = (e) => {
			this.eventEmitter.emit("click", e);
		}
	}

	public onClick(callback: (event: MouseEvent) => void) {
		return this.eventEmitter.subscribe("click", callback);
	}
}